module.exports = __webpack_public_path__ + "public-ui/fonts/math.c127ab3c.woff2";